import { cssClass } from "../../core/index.js";
export const cssPrefix = (className) => cssClass(`slide_${className}`);
